import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles, Theme } from "@material-ui/core/styles"
import { ProjectDashboardViewModel } from "../../api/project-dashboard"
import { useTranslations } from "./useTranslations"
import { COLOR_GRAY } from "../../../constants"

const Resources = ({ projectDashboard }: ResourcesProps) => {
  const classes = useStyles()
  const translations = useTranslations()

  return (
    <Grid container direction="row" className={classes.container}>
      <Grid item xs={12} className={classes.gridItem}>
        <Card variant="outlined" className={classes.card}>
          <CardHeader title={translations.projectManagerCardHeader} className={classes.cardHeader} disableTypography />
          <CardContent className={classes.cardContent}>
            <Typography variant="h4">{projectDashboard.projectManagers.join(", ")}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} className={classes.gridItem}>
        <Card variant="outlined" className={classes.card}>
          <CardHeader
            title={translations.projectParticipantsCardHeader}
            className={classes.cardHeader}
            disableTypography
          />
          <CardContent className={classes.cardContent}>
            <Typography variant="h4">{projectDashboard.projectParticipants.join(", ")}</Typography>
            <Typography variant="h4">{projectDashboard.projectSuppliers.join(", ")}</Typography>
            <Typography variant="h4">{projectDashboard.projectWorkspaces.join(", ")}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} className={classes.gridItem}>
        <Card variant="outlined" className={classes.card}>
          <CardHeader title={translations.taskResourcesCardHeader} className={classes.cardHeader} disableTypography />
          <CardContent className={classes.cardContent}>
            <Typography variant="h4">{projectDashboard.taskResources.join(", ")}</Typography>
            <Typography variant="h4">{projectDashboard.taskSuppliers.join(", ")}</Typography>
            <Typography variant="h4">{projectDashboard.taskWorkspaces.join(", ")}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

type ResourcesProps = {
  projectDashboard: ProjectDashboardViewModel
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing(1),
    "&:last-child": {
      paddingBottom: 0,
    },
  },
  card: {
    flex: 1,
  },
  cardHeader: {
    color: COLOR_GRAY,
    fontSize: "1rem",
    paddingBottom: 0,
  },
  cardContent: {
    "& h6": {
      fontWeight: 400,
    },
    paddingTop: 0,
  },
}))

export default Resources
